<template>
	<div class="yh-bg-color">
		<div style="float: left;margin-top: 20px;margin-left: 20px;">
			<el-image style="width: 158px; height: 46px" :src="require('@/assets/images/yh-logo-1.png')"  fit="cover"></el-image>
		</div>
		<div style="float: right;width: 320px;height: 370px;margin-top: 160px;
			margin-right: 120px; border-radius: 10px;background-color: #fff;">
			<div style="height: 100px;line-height: 100px;display: flex;justify-content: center;align-items: center;">
				<el-image style="width: 36px; height: 36px" :src="logourl"  fit="cover"></el-image>
				<span style="margin-left: 20px;">{{ title }}</span>
			</div>	
			<el-form style="padding-left: 40px;padding-right: 40px;">
				<el-form-item >
				    <el-input clearable prefix-icon="el-icon-user-solid" autofocus placeholder="请输入账号" v-model="formdata.username"></el-input>
				</el-form-item>
				<el-form-item >
				    <el-input clearable prefix-icon="el-icon-star-on" type="password" :show-password="true" placeholder="请输入密码" v-model="formdata.userpwd"></el-input>
				</el-form-item>
				<el-form-item style="margin-bottom:0px;">
					<el-row>
						<el-col :span="12">
							 <el-input clearable prefix-icon="el-icon-warning" placeholder="短信验证码" v-model="formdata.smscode"></el-input>
						</el-col>
						<el-col :span="12">
							<el-button type="primary" :disabled="smsdisable" @click="sendSms">{{smsbtnword}}</el-button>
						</el-col>
					</el-row>
				</el-form-item>
				<el-form-item style="margin-bottom:0px;">
				    <div style="float: right;">
						<a @click="gotoForgotPwd">忘记密码？</a>
					</div>
				</el-form-item>
				<el-form-item >
				   <el-button style="width: 100%;" type="primary" @click="submitLogin">登录</el-button>
				</el-form-item>
			</el-form>
				
		</div>	
		
		<div style="position: absolute;bottom: 0px;margin-bottom: 20px;color: #7EA8EB;
			text-align: center;width: 99%;font-size: 12px;">
			<div style="">
				Copyright @ 2024-2099 Sinowyde. All Right Reserved.
			</div>
			<div style="">
				@ 2024-2099 版权所有 宇衡金凯 | 京ICP备2023023002号-4
			</div>
		</div>
	</div>
</template>

<script>
	import {userLogin,getSmsCode } from '/static/apiUrl.js'
	export default {
		name : 'YHLogin',
		data() {
			return {
				logourl : "logo.png",
				smsbtnword : '发送验证码',
				countdown : 60,
				smsdisable : false,
				//leftlogourl : "@/assets/images/yh-logo-1.png",
				title : '理想美食城外卖平台',
				formdata : {
					username : '',
					userpwd : '',
					smscode : '',
				},
				
			}
		},
		mounted() {
			document.querySelector('body').setAttribute('style', 'background-color:#4E73DF')
			
		},
		beforeCreate () {
			document.querySelector('body').setAttribute('style', 'background-color:#4E73DF')
		},
		beforeDestroy () {
			document.querySelector('body').setAttribute('style', 'background-color:#FFF')
		},
		methods: {
			gotoForgotPwd(){
				console.log('忘记密码')
				this.$router.push({ name: 'ForgotPassword' });
			},
			submitLogin(){
				if(this.formdata.username === null || this.formdata.username == ''){
					this.$message({
						showClose: true,
						message: '请输入账号',
						type: 'error'
					});
					return;
				}
				if(this.formdata.userpwd === null || this.formdata.userpwd == ''){
					this.$message({
						showClose: true,
						message: '请输入密码',
						type: 'error'
					});
					return;
				}
				if(this.formdata.smscode === null || this.formdata.smscode == ''){
					this.$message({
						showClose: true,
						message: '请输入短信验证码',
						type: 'error'
					});
					return;
				}
				userLogin({
					name: this.formdata.username,
					password: this.$md5(this.formdata.userpwd),
					smscode: this.formdata.smscode
				}).then((res) => {
					console.log(res)
					if(0 == res.code){
						let userinfo = {
							realname : res.data.realname,
							username : res.data.username,
							userid: res.data.id,
							org_id : res.data.org_id,
							org_name : res.data.org_name
						}
						localStorage.setItem("bUserinfo",JSON.stringify(userinfo))
						sessionStorage.setItem("authToken", res.data.token);
						this.$router.push({ name: 'Home' });
					}else{
						this.$message({
							showClose: true,
							message: res.msg,
							type: 'error'
						});
					}
				}).catch((err) => {
					console.log(err)
				})
				//
			},
			sendSms(){
				if(this.formdata.username == null || this.formdata.username == ''){
					this.$message({
						showClose: true,
						message: '请先输入账号',
						type: 'error'
					});
				}else{
					//发送短信验证码
					this.GetSmsCode("login")
					
					this.smsdisable = true
					this.smsbtnword = '60s后重试'
					let pthis = this
					let timeout = setInterval(()=>{
						pthis.countdown--
						if(pthis.countdown == 0){
							clearInterval(timeout)
							pthis.smsdisable = false
							pthis.smsbtnword = '发送验证码'
							pthis.countdown = 60
						}else{
							pthis.smsbtnword = pthis.countdown + 's后重试'
						}
					},1000)
				}
			},
			GetSmsCode(type){
				getSmsCode({
					username: this.formdata.username,
					type: type,
				}).then(res => {
					if (0 == res.code) {
						console.log("")
					}
				})
			},
		}
	}
</script>

<style scoped>
	
</style>